import { __awaiter } from "tslib";
import { fileToBase64 } from '@shared/lib/file-upload';
export const prepareExareInputFiles = (documents) => __awaiter(void 0, void 0, void 0, function* () {
    const files = [];
    const errors = [];
    for (const document of documents) {
        for (const file of document.files) {
            try {
                if (!file.error) {
                    const content = yield fileToBase64(file.file);
                    files.push({
                        content,
                        originalFileName: file.file.name,
                        type: document.documentType,
                        passengerId: document.passengerId
                    });
                }
            }
            catch (error) {
                errors.push({ document, error });
            }
        }
    }
    return { files, errors };
});
